import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/yunpan-icon@3x.png';
const _withScopeId = n => (_pushScopeId("data-v-3f7bd9c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 0,
  class: "file-item-tackback",
  src: _imports_0,
  draggable: "false"
};
const _hoisted_3 = {
  class: "file-item__main"
};
const _hoisted_4 = {
  class: "file-item__name"
};
const _hoisted_5 = {
  class: "file-item__speed"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "file-item",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.handleSelect && _ctx.handleSelect(...args))
  }, [_createElementVNode("img", {
    class: "file-item__pic",
    src: _ctx.iconLink,
    alt: "图片",
    draggable: "false"
  }, null, 8, _hoisted_1), _ctx.file.type === 'user#download' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("article", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.file.file_name || _ctx.file.name), 1), _createElementVNode("section", null, [_createElementVNode("p", _hoisted_5, [_withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(new Date(_ctx.file.created_time))), 513), [[_vShow, _ctx.taskType !== 'ing']]), _withDirectives(_createElementVNode("span", {
    style: {
      "margin-left": "5px"
    }
  }, _toDisplayString(_ctx.size), 513), [[_vShow, _ctx.file.kind !== 'drive#folder']])])])])]);
}